s<template>
    <div id="step-3" class="d-flex flex-column h-100 w-100">
        <div class="row d-flex justify-content">
            <div class="d-flex flex-column justify-content-start align-items-center w-100 mt-8 mt-md-12  mb-10">
                <div class="d-flex align-items-center justify-content-centers justify-content-start w-100">
                    <span class="counter text-white mr-4" :class="`bg-${colour}`">3</span>
                    <h3 v-if="isSilage" class="text-white mb-0 text-uppercase">Select your ideal dates</h3>

                    <div v-else class="d-flex flex-column align-items-start">
                        <h3 class="text-white mb-0 text-left">Select your ideal maturity</h3>
                        <h4 class="text-white mb-0">(Choose one or more)</h4>
                    </div>
                </div>
            </div>


            <!-- Silage Dates -->
            <div v-if="isSilage" class="row mb-6 mb-10 ml-lg-4_ mx-xl-11 w-100">
                <div class="col mx-auto text-md-left">
                    <div class="row">
                        <div class="col-md-6 col-lg-4 col-xl-4 text-center">
                            <h4 class="text-white">Plant</h4>
                            <b-calendar id="plantDate" ref="plantDate" v-bind:key="`plantDate`"
                                v-model="plantDate"
                                v-on:input="calculateHarvestDays"
                                :date-format-options="{'year': 'numeric', 'month': 'short', 'day': 'numeric', 'weekday': 'short'}"
                                :min="minPlantDate"
                                :max="maxPlantDate"
                                :initial-date="minPlantDate"
                                class="datepicker-selector"
                                nav-button-variant="primary"
                                weekday-header-format="narrow"
                                label-no-date-selected="Select day"
                                locale="en"></b-calendar>
                        </div>
                        <div class="col-md-6 col-lg-5 col-xl-4 text-center mt-5 mt-md-0">
                            <h4 class="text-white">Harvest</h4>
                            <b-calendar id="harvestDate" ref="harvestDate" v-bind:key="`harvestDate`"
                                v-model="harvestDate"
                                v-on:input="calculateHarvestDays"
                                :date-format-options="{'year': 'numeric', 'month': 'short', 'day': 'numeric', 'weekday': 'short'}"
                                :initial-date="minHarvestDate"
                                :min="minHarvestDate"
                                :max="maxHarvestDate"
                                class="datepicker-selector"
                                nav-button-variant="primary"
                                weekday-header-format="narrow"
                                label-no-date-selected="Select day"
                                locale="en"></b-calendar>

                        </div>
                        <div class="col col-md col-lg-12_ col-xl-4 text-center">
                            <h4>&nbsp;</h4>
                            <h3 class="text-white">
                            Estimated days from
                            <br class="d-lg-none">planting
                            <br class="d-none d-lg-block d-xl-none">to harvest
                            </h3>
                            <span v-html="days" class="days mb-4" :class="`bg-${colour}`"></span>
                            <p v-if="!_.isEmpty(harvestRange)" class="mb-0 text-white ">
                                Available range for this region is:
                                <span class="nowrap"><strong>{{ harvestRange.min }}</strong>&ndash;<strong>{{ harvestRange.max }}</strong></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Grain Maturity -->

            <div v-else class="mb-9 mb-lg-17 mx-auto px-2 mt-xl-16 w-100">
                <div class="row d-flex justify-content-center">
                    <div v-for="(item,index) in maturityFilters" v-bind:key="index" class="col-6 col-md">
                        <div class="btn-group-toggle mb-3" data-toggle="buttons">
                            <label class="btn btn-checkbox btn-checkbox__yellow">
                                <input v-model="idealMaturity" type="checkbox" :value="index">
                                {{ item.name }}
                            </label>
                        </div>
                        <h5 class="text-white grain-h5">
                            CRM range
                            <br>
                            {{ item.description }}
                        </h5>
                    </div>

                </div>
            </div>


            <div class="d-flex justify-content-center mx-auto w-100">
                <button v-on:click="back()" class="btn btn-md btn-outline-white px-9_ mr-2">
                    Back
                </button>
                <button v-on:click="forward()" :disabled="!isValid" class="btn btn-md"
                    :class="[{'disabled' : !isValid}, isValid ? `btn-${colour}` : 'btn-outline-white' ]">
                    Find Hybrids
                </button>
            </div>



        </div>
    </div>
</template>
<script>
import UtilsMixin from '../UtilsMixin';

export default {
    data() {

        return {
            options: [
                {
                    id: 'Ultra Early',
                    name: 'Ultra Early',
                    description: '< 85',
                    cssClass: 'col-6 col-md-3 mb-3 mb-md-0 px-2 px-md-3',
                    min: 0,
                    max: 86,
                },
                {
                    id: 'Very Early',
                    name: 'Very Early',
                    description: '86 - 93',
                    cssClass: 'col-6 col-md-3 mb-3 mb-md-0 px-2 px-md-3',
                    min: 86,
                    max: 93,
                },
                {
                    id: 'Early',
                    name: 'Early',
                    description: '94 - 99',
                    cssClass: 'col-6 col-md-3 mb-3 mb-md-0 px-2 px-md-3',
                    min: 94,
                    max: 99,
                },
                {
                    id: 'Mid',
                    name: 'Mid',
                    description: '100 - 106',
                    cssClass: 'col-6 col-md-3 mb-3 mb-md-0 px-2 px-md-3',
                    min: 100,
                    max: 106,
                },
                {
                    id: 'Full',
                    name: 'Full',
                    description: '> 107',
                    cssClass: 'col-6 col-md-3 mb-3 mb-md-0 px-2 px-md-3',
                    min: 107,
                    max: 1000,
                },
            ],
            plantDate: null,
            harvestDate: null,
            idealMaturity: [],
            days: 0,
        }
    },

    mixins: [UtilsMixin],

    props: ['config', 'value', 'type', 'harvestRange'],

    watch: {
        plantDate(newVal) {
            // select harvest date if not set
            if(!this.harvestDate){
                this.harvestDate = this.minHarvestDate;
            }
        }
    },

    computed: {
        colour() {
            return this.type == 'silage' ? 'primary' : 'yellow';
        },

        isSilage() {
            return this.type == 'silage' ? true : false;
        },

        maturityFilters(){
            return _.chain(this.config)
                .get('filters.grain.maturity.values', [])
                .value();
        },

        maturity() {
            switch(this.type){
                case 'silage':
                    return {
                        'harvestDate': this.harvestDate,
                        'plantDate': this.plantDate,
                        'days': this.days
                    };
                    break;
                case 'grain':
                    return {
                        'crm': this.idealMaturity
                    }
            }
            return {};
        },

        minPlantDate(){
            let date = new Date(this.todaysDate);
            let curMonth = date.getMonth();

            // Set to September 1
            if(curMonth <= 8){
                date.setMonth(8)
                date.setDate(1);
            }

            return date;
        },
        maxPlantDate(){
            let date = new Date(this.todaysDate);
                date.setMonth(11)
                // Set to December 31
                date.setDate(31);
            return date;
        },
        initialPlantDate(){
            let date = new Date(this.todaysDate);
                date.setMonth(date.getMonth() + 2)
                date.setDate(1);

            return date;
        },
        minHarvestDate(){
            let date = new Date(this.minPlantDate);

            if(this.plantDate){
                date = new Date(this.plantDate);
            }
            // set max date based on plant date
            if(this.harvestRange.min){
                date = this.addDays(date, this.harvestRange.min);
                return date;
            }

            // default
            date.setMonth(date.getMonth() + 4);
            date.setDate(1);

            return date;
        },
        maxHarvestDate(){
            let date = new Date(this.initialPlantDate);

            if(this.plantDate){
                date = new Date(this.plantDate);
            }
            // set max date based on plant date
            if(this.harvestRange.max){
                date = this.addDays(date, this.harvestRange.max);
                return date;
            }

            date.setMonth(date.getMonth() + 4);

            return date;
        },

        isValid() {
            switch(this.type){
                case 'silage':
                    return !_.isEmpty(this.harvestDate) && !_.isEmpty(this.plantDate) && this.maturity.days >= this.harvestRange.min && this.maturity.days <= this.harvestRange.max;
                    break;

                case 'grain':
                    return !_.isEmpty(this.idealMaturity);
            }
        },
    },

    methods: {
        calculateHarvestDays() {
            this.days = this.getHarvestDays(this.plantDate, this.harvestDate);
        },
        updateValue(option) {
            this.$emit('input', option);
        },
        back() {
            this.$emit('back');
        },
        forward() {

            this.updateValue(this.maturity);

            this.$emit('forward');
        },
    },
}
</script>
